{
    "(None)": "",
    "(save {highestYearlyDiscount}%)": "(spar {highestYearlyDiscount}%)",
    "{amount} days free": "{amount} dager gratis",
    "{amount} off": "{amount} rabatt",
    "{amount} off for first {number} months.": "{amount} rabatt første {number} måneder.",
    "{amount} off for first {period}.": "{amount} rabatt for første {period}.",
    "{amount} off forever.": "{amount} rabatt for alltid.",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}% rabatt",
    "{duration} membership": "",
    "{field}: {message}": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} vil ikke lenger motta nyhetsbrevet {newsletterName}.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} vil ikke lenger motta e-poster når noen svarer på dine kommentarer.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} vil ikke lenger motta nyhetsbrevet.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} dager gratis",
    "{years} years": "",
    "+1 (123) 456-7890": "+47 123 45 678",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Konto",
    "Account details updated successfully": "Kontodetaljer oppdatert",
    "Account settings": "Kontoinnstillinger",
    "Add a personal note": "",
    "Add a short note to go with your gift": "",
    "Address line 1": "",
    "Address line 2": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Etter at prøveperioden er over, vil du bli belastet den vanlige prisen for nivået du har valgt. Du kan alltid avbryte før det.",
    "Already a member?": "Allerede medlem?",
    "An error occurred": "En feil oppstod",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "En uforutsett feil oppstod. Vennligst prøv igjen eller <a>ta kontakt</a> hvis feilen vedvarer.",
    "Back": "Tilbake",
    "Back to Log in": "Tilbake til innlogging",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Black Friday",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "Ingen bindingstid.",
    "Cancel subscription": "Kanseller abonnement",
    "Canceled": "",
    "Cancellation reason": "Årsak til kansellering",
    "Change": "Endre",
    "Change plan": "Endre avtale",
    "Check spam & promotions folders": "Sjekk søppelpost og reklame",
    "Check with your mail provider": "Sjekk med din e-postleverandør",
    "Check your inbox to verify email update": "Sjekk innboksen for å bekrefte e-postoppdatering",
    "Choose": "Velg",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Velg en annen avtale",
    "Choose a plan": "Velg en avtale",
    "Choose a tier": "",
    "Choose your newsletters": "Velg nyhetsbrev",
    "City": "",
    "Click here to retry": "Klikk her for å prøve igjen",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Lukk",
    "Code": "",
    "Comment preferences updated.": "Innstillingene for kommentarer ble oppdatert.",
    "Comments": "Kommentarer",
    "Complimentary": "Gratis",
    "Confirm": "Bekreft",
    "Confirm cancellation": "Bekreft kansellering",
    "Confirm subscription": "Bekreft abonnement",
    "Contact support": "Kontakt support",
    "Continue": "Fortsett",
    "Continue subscription": "Fortsett abonnement",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "Kunne ikke opprette utsjekkingssesjon hos Stripe",
    "Could not sign in. Login link expired.": "Kunne ikke logge inn. Påloggingslenken har utløpt.",
    "Could not update email! Invalid link.": "Kunne ikke oppdatere e-post! Ugyldig lenke.",
    "Country": "",
    "Create a new contact": "Opprett en ny kontakt",
    "Current plan": "Nåværende avtale",
    "Delete account": "Slett konto",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Var dette en feil? Administrer innstillingene dine <button>her</button>.",
    "Don't have an account?": "Har du ikke konto?",
    "Edit": "Rediger",
    "Email": "E-post",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "E-postnyhetsbrev",
    "Email newsletter settings updated": "Innstillinger for e-postnyhetsbrev oppdatert",
    "Email preferences": "E-postinnstillinger",
    "Email preferences updated.": "E-postinnstillinger oppdatert",
    "Emails": "E-poster",
    "Emails disabled": "E-poster deaktivert",
    "Ends {offerEndDate}": "Avsluttes {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "Oppgi din e-postadresse",
    "Enter your name": "Oppgi navnet ditt",
    "Error": "Feil",
    "Expires {expiryDate}": "Utløper {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "Kansellering mislyktes, vennligst prøv igjen",
    "Failed to log in, please try again": "Innlogging mislyktes, vennligst prøv igjen",
    "Failed to log out, please try again": "Utlogging mislyktes, vennligst prøv igjen",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "Betaling mislyktes, vennligst prøv igjen",
    "Failed to send magic link email": "Kunne ikke sende lenke på e-post",
    "Failed to send verification email": "Kunne ikke sende bekreftelses-e-post",
    "Failed to sign up, please try again": "Registrering mislyktes, vennligst prøv igjen",
    "Failed to update account data": "Kunne ikke oppdatere kontodata",
    "Failed to update account details": "Kunne ikke oppdatere kontodetaljer",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "Kunne ikke oppdatere nyhetsbrevinnstillinger",
    "Failed to update subscription, please try again": "Kunne ikke oppdatere abonnement, vennligst prøv igjen",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "For alltid",
    "Free Trial – Ends {trialEnd}": "Gratis prøveperiode – avsluttes {trialEnd}",
    "From": "",
    "Get help": "Få hjelp",
    "Get in touch for help": "Kontakt for hjelp",
    "Get notified when someone replies to your comment": "Få varsel når noen svarer på kommentaren din",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Gi tilbakemelding på dette innlegget",
    "Help! I'm not receiving emails": "Hjelp! Jeg mottar ikke e-poster",
    "Here are a few other sites you may enjoy.": "Her er noen andre nettsteder du kanskje liker.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Hvis et nyhetsbrev er markert som søppelpost, blir e-poster automatisk deaktivert for den adressen.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Hvis du merket som søppelpost ved et uhell eller vil begynne å motta e-poster igjen, kan du abonnere på nytt ved å klikke knappen på forrige skjerm.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Hvis du avslutter abonnementet ditt nå, vil du fortsatt ha tilgang til {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Hvis du har en bedrifts- eller offentlig e-post, kontakt IT-avdelingen og be dem godkjenne e-post fra {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "En påloggingslenke har blitt sendt til innboksen din. Hvis den ikke kommer innen 3 minutter, må du sjekke søppelposten din.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Hvis du vil begynne å motta e-poster igjen, sjekk e-postadressen din og klikk abonner på nytt på forrige skjerm.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Hvis du ikke mottar e-posten du har abonnert på, er her noen ting å sjekke.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Hvis du har sjekket alt og fortsatt ikke mottar e-poster, kontakt {supportAddress}.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "Hvis en permanent feil oppstår ved sending av nyhetsbrev, vil e-post bli deaktivert på kontoen.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Legg til {senderEmail} i kontaktlisten din i e-postklienten. Dette signaliserer til e-postleverandøren din at e-poster sendt fra denne adressen skal være pålitelige.",
    "Invalid email address": "Ugyldig e-postadresse",
    "Invalid verification code": "",
    "Jamie Larson": "Ola Nordmann",
    "jamie@example.com": "ola.nordmann@example.com",
    "Less like this": "Mindre som dette",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Sørg for at e-poster ikke ender opp i spam- eller reklame-mappene ved en feil. Hvis de gjør det, klikk \"Merk som ikke søppel\" eller \"Flytt til innboks\".",
    "Manage": "Administrer",
    "Maybe later": "Kanskje senere",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "Medlemskap ikke tilgjengelig, ta kontakt for tilgang.",
    "month": "måned",
    "Monthly": "Månedlig",
    "More like this": "Mer som dette",
    "More options": "",
    "Name": "Navn",
    "Need more help? Contact support": "Trenger du mer hjelp? Ta kontakt",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Nyhetsbrev kan bli deaktivert på kontoen din av to grunner: En tidligere e-post ble markert som søppelpost, eller forsøk på å sende e-post resulterte i en permanent feil (bounce).",
    "No member exists with this e-mail address.": "Ingen medlem eksisterer med denne e-postadressen.",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Mottar du ikke e-poster?",
    "Now": "",
    "Now check your email!": "Sjekk e-posten din nå!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Blir e-poster markert som søppelpost? Sjekk e-postmappen for søppelpost og merk som 'ikke søppel'.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Permanent feil (bounce)",
    "Phone number": "Telefonnummer",
    "Plan": "Avtale",
    "Plan checkout was cancelled.": "Påmelding til avtale ble kansellert.",
    "Plan upgrade was cancelled.": "Oppgradering ble kansellert.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Vennligst kontakt {supportAddress} for å justere ditt gratis abonnement.",
    "Please enter {fieldName}": "Vennligst oppgi {fieldName}",
    "Please fill in required fields": "Vennligst fyll inn påkrevde felt",
    "Podcasts": "",
    "Postal code": "",
    "Re-enable emails": "Re-aktiver e-poster",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "Anbefalinger",
    "Redeem your gift": "",
    "Redeeming...": "",
    "Renews at {price}.": "Fornyes til {price}.",
    "Resume subscription": "",
    "Retry": "Prøv på nytt",
    "Save": "Lagre",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Security verification": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Sender påloggingslenke...",
    "Sending...": "Sender...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "Vis alt",
    "Sign in": "Logg inn",
    "Sign out": "Logg ut",
    "Sign up": "Opprett bruker",
    "Signup error: Invalid link": "Feil ved registrering: Ugyldig lenke",
    "Signups from this email domain are currently restricted.": "Registrering fra dette e-postdomenet er utilgjengelig for øyeblikket.",
    "Something went wrong, please try again later.": "Noe gikk galt. Prøv igjen senere.",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "Beklager, ingen anbefalinger er tilgjengelige for øyeblikket.",
    "Sorry, that didn’t work.": "Beklager, det fungerte ikke",
    "Spam complaints": "Søppelpostklager",
    "Start {amount}-day free trial": "Start gratis prøveperiode på {amount} dager",
    "Starting {startDate}": "Oppstart {startDate}",
    "Starting today": "Starter i dag",
    "State": "",
    "Submit feedback": "Send tilbakemelding",
    "Subscribe": "Abonner",
    "Subscribed": "Abonnert",
    "Subscription plan updated successfully": "Abonnementsavtale oppdatert",
    "Success": "Suksess",
    "Success! Check your email for magic link to sign-in.": "Suksess! Sjekk din e-post for magisk lenke for pålogging.",
    "Success! Your account is fully activated, you now have access to all content.": "Suksess! Din konto er nå aktivert, og du har tilgang til alt innhold.",
    "Success! Your email is updated.": "Suksess, din e-post er oppdatert",
    "Successfully unsubscribed": "Avmelding vellykket",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Takk for at du abonnerer. Før du begynner å lese, nedenfor er noen andre nettsteder du kan ha glede av.",
    "Thank you for your support": "Takk for din støtte",
    "Thank you for your support!": "Takk for din støtte!",
    "Thanks for the feedback!": "Takk for tilbakemeldingen!",
    "That didn't go to plan": "Det gikk ikke som planlagt",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "E-postadressen vi har til deg er {memberEmail} – hvis det ikke er riktig, kan du oppdatere den i <button>kontoinnstillinger</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "Det oppstod en feil. Vennligst prøv igjen senere.",
    "There was an error cancelling your subscription, please try again.": "En feil oppstod ved kansellering av abonnementet, vennligst prøv igjen.",
    "There was an error continuing your subscription, please try again.": "En feil oppstod ved fornyelse av abonnementet, vennligst prøv igjen.",
    "There was an error processing your payment. Please try again.": "Det oppsto en feil under behandling av betalingen din. Vennligst prøv igjen.",
    "There was an error sending the email, please try again": "En feil oppstod ved sending av e-posten, vennligst prøv igjen",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Denne nettsiden er kun for inviterte. Kontakt eieren for invitasjon.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "Denne nettsiden godtar ikke betalinger for øyeblikket.",
    "This site only accepts paid members.": "Denne nettsiden er kun for betalende medlemmer.",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "For å fullføre registreringen, klikk på bekreftelseslenken i innboksen din. Hvis den ikke kommer innen 3 minutter, må du sjekke søppelposten din!",
    "To continue to stay up to date, subscribe to {publication} below.": "For å fortsette å holde deg oppdatert, abonner på {publication} nedenfor.",
    "Too many attempts try again in {number} days.": "For mange forsøk, prøv igjen om {number} dager.",
    "Too many attempts try again in {number} hours.": "For mange forsøk, prøv igjen om {number} timer.",
    "Too many attempts try again in {number} minutes.": "For mange forsøk, prøv igjen om {number} minutter.",
    "Too many different sign-in attempts, try again in {number} days": "For mange påloggingsforsøk, prøv igjen om {number} dager.",
    "Too many different sign-in attempts, try again in {number} hours": "For mange påloggingsforsøk, prøv igjen om {number} timer.",
    "Too many different sign-in attempts, try again in {number} minutes": "For mange påloggingsforsøk, prøv igjen om {number} minutter.",
    "Too many sign-up attempts, try again later": "For mange registreringsforsøk, prøv igjen senere",
    "Try free for {amount} days, then {originalPrice}.": "Prøv gratis i {amount} dager, deretter {originalPrice}.",
    "Unable to initiate checkout session": "Kunne ikke starte utsjekkingssesjon",
    "Unable to verify your request, please try again": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Få tilgang til alle nyhetsbrev ved å bli betalende abonnent.",
    "Unsubscribe from all emails": "Meld deg av alle e-poster",
    "Unsubscribed": "Avmeldt",
    "Unsubscribed from all emails.": "Avmeldt fra alle e-poster",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Å melde seg av e-poster vil ikke avbryte abonnementet ditt på {title}",
    "Update": "Oppdater",
    "Update your preferences": "Oppdater dine valg",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Lenke for verifisering er sendt. Sjekk innboksen din.",
    "Verify your email address is correct": "Verifiser at e-posten din er korrekt",
    "Verifying...": "",
    "View plans": "Se planer",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Vi kunne ikke melde deg av siden e-postadressen ikke ble funnet. Vennligst kontakt nettstedseieren.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Velkommen tilbake, {name}!",
    "Welcome back!": "Velkommen tilbake!",
    "Welcome to {siteTitle}": "Velkommen til {siteTitle}",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Når en e-postadresse ikke kan motta e-post, kalles det en bounce. I mange tilfeller kan dette være midlertidig, men noen ganger kan det være en permanent feil hvis e-postadressen er ugyldig eller ikke eksisterer.",
    "Why has my email been disabled?": "Hvorfor fungerer ikke min e-post?",
    "X (Twitter)": "",
    "year": "år",
    "Yearly": "Årlig",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Du har for tiden et gratis medlemskap. Oppgrader til et betalt abonnement for full tilgang.",
    "You have been successfully resubscribed": "Du har blitt meldt på igjen",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Du mottar for tiden ikke e-poster",
    "You're not receiving emails": "Du mottar ikke e-poster",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Du mottar ikke e-poster fordi du enten nylig har merket en melding som søppelpost, eller fordi meldinger ikke kunne leveres til den oppgitte e-postadressen din.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've successfully signed in.": "Du har logget på.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Du har meldt deg på <strong>{siteTitle}</strong>",
    "Your account": "Din konto",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "E-posten din kunne ikke bli meldt på igjen, vennligst prøv på nytt",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Din tilbakemelding bidrar til å påvirke hva som blir publisert.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Ditt abonnement vil avsluttes den {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Ditt abonnement vil fornyes den {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Ditt abonnement vil starte den {subscriptionStart}"
}
